// enable-high-contrast button footer

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.toggle-password').forEach(icon => {
    icon.addEventListener('click', function () {
      const input = document.getElementById(this.dataset.target);

      if (input.type === "password") {
        input.type = "text";
      } else {
        input.type = "password";
      }
    });
  });

  // product page share button
  let shareButtonWrapper = document.querySelector('.parent-share');
  let sharePopupWrapper = document.querySelector('.sharing');

  if (shareButtonWrapper && sharePopupWrapper) {
    shareButtonWrapper.addEventListener('click', e => {
      e.stopPropagation();
      shareButtonWrapper.classList.toggle('active');
      sharePopupWrapper.classList.toggle('active');
    });

    document.addEventListener('click', () => {
      shareButtonWrapper.classList.remove('active');
      sharePopupWrapper.classList.remove('active');
    });
  }
  let sharingSocialShare = document.querySelector(".sharing-socialshare");
  if (sharingSocialShare) {
    sharingSocialShare.addEventListener('click', function () {
      const shareThisBtn = document.querySelector('.st-btn.st-last[data-network="sharethis"]');
      if (shareThisBtn) {
        shareThisBtn.click();
      } else {
        console.warn("ShareThis button not found");
      }
    });
  }

let highContrastToggle = document.querySelector("#enable-high-contrast");
let footerSection = document.querySelector(".footer_block-adress-with-menus");
let bodyinfo = document.querySelector("body");

// Restore state on page load
if (sessionStorage.getItem("highContrastEnabled") === "true") {
  bodyinfo.classList.add("high-contrast");
  footerSection?.classList.add("footer-checked-active");
  if (highContrastToggle) {
    highContrastToggle.checked = true;
  }
}

// Toggle change handler
if (highContrastToggle) {
  highContrastToggle.addEventListener("change", function () {
    if (this.checked) {
      bodyinfo.classList.add("high-contrast");
      footerSection?.classList.add("footer-checked-active");
      sessionStorage.setItem("highContrastEnabled", "true");
    } else {
      bodyinfo.classList.remove("high-contrast");
      footerSection?.classList.remove("footer-checked-active");
      sessionStorage.setItem("highContrastEnabled", "false");
    }
  });
}



  // Single Qty Purchase for remnanat product
  let remnantProduct = document.querySelector(".product-form__buttons.is_remnant_true");
  if (remnantProduct) {
    document.querySelector('.product-form__buttons.is_remnant_true .product-form__submit').addEventListener('click', function (e) {
      const addToCartBtn = this;
      const productId = addToCartBtn.getAttribute('data-product-id');
      setTimeout(() => {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            const itemInCart = cart.items.find(item => item.variant_id == productId);
            if (itemInCart) {
              // console.log('Item added to cart (checked after delay)');
              addToCartBtn.disabled = true;
            } else {
              // console.log('Item still not in cart after timeout.');
            }
          })
          .catch(err => {
            console.error('Error fetching cart:', err);
          });
      }, 2000);
    });
    document.addEventListener('click', function (e) {
      const removedButton = e.target.closest('.cart-remove-button.is_remnant_true');
      if (removedButton) {
        const productId = removedButton.getAttribute('data-variant-id');
        setTimeout(() => {
          fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
              const itemStillInCart = cart.items.find(item => item.variant_id == productId);
              const addToCartBtn = document.querySelector('.product-form__buttons.is_remnant_true .product-form__submit');
              if (addToCartBtn && (!itemStillInCart || !productId)) {
                addToCartBtn.disabled = false;
                // console.log('Item removed — button re-enabled');
              } else {
                // console.log('Item still in cart or no match');
              }
            })
            .catch(err => {
              console.error('Error fetching cart after remove:', err);
            });
        }, 2000);
      }
    });
  }

  const cartDrawer = document.querySelector("cart-drawer");
  if (!cartDrawer) return;
  const getSectionsToRender = () => {
    return cartDrawer.getSectionsToRender().map(section => section.id);
  };
  const sections_url = window.location.pathname;

  document.addEventListener('change', function (event) {
    const checkbox = event.target.closest('.upsell-checkbox');
    // console.log("Checking 123 ");
    if (!checkbox) return;
    // console.log("Checking yes ");

    const variantId = checkbox.dataset.id;
    const skuElement = checkbox.dataset.sku; 
    // console.log("skuElement", skuElement);
    const sectionsToRender = getSectionsToRender();



    if (checkbox.checked) {      
      let properties = {
        SKU: skuElement
      };

const progressEl = document.querySelector('.block_drawer-progress');

if (progressEl) {
  const freeGiftMin = parseInt(progressEl.getAttribute('data_add_freegift_price'), 10);
  const cartTotal = parseInt(progressEl.getAttribute('data-cart-total'), 10);

  if (
    cartTotal >= freeGiftMin &&
    document.querySelectorAll('.freemood-item').length <= 0 &&
    checkbox.getAttribute('data-id') ===
      document
        .querySelector('.block_cart-drawer-giftproduct')
        ?.getAttribute('data-freegiftid')
  ) {
    properties._mood_tag = "true";
  }
}



      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ 
            id: variantId,
            quantity: 1, 
            properties: properties
          }],
          sections: sectionsToRender,
          sections_url: sections_url
        }) 
      })
        .then(res => res.json())
        .then(cart => {
          cartDrawer.renderContents(cart);
          setTimeout(function () {
            // Serialize + lock the drawer for background cart mutations (free gift,
            // shipping protection) so Measura can't edit a line whose index shifts.
            if (typeof mfReconcileCartBackground === 'function') {
              mfReconcileCartBackground();
            }
            moodRewars();
          }, 500);
        });

      

   

    } else {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          const item = cart.items.find(i => i.variant_id == variantId);
          if (item) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                id: item.key,
                quantity: 0,
                sections: sectionsToRender,
                sections_url: sections_url
              })
            })
              .then(res => res.json())
              .then(updatedCart => {
                cartDrawer.renderContents(updatedCart);
                setTimeout(function () {
                  if (document.querySelector('.block_cart-drawer-giftproduct')) {
                    // addFreeGiftProduct();
                  }
                  moodRewars();
                }, 500);
              });
          }
        });
    }
  });

  document.addEventListener("click", function (event) {
    // Check if the clicked element matches any of the selectors
    if (event.target.closest(".cart_recommendation .rebuy-button")) {
      var clickedElement = event.target;
      var interval = setInterval(doStuff, 100);

      function doStuff() {
        // Find the closest rebuy-widget-container
        var container = clickedElement.closest(".rebuy-widget-container");
        if (!container) {
          clearInterval(interval);
          return;
        }

        // Find the rebuy-button inside that container
        var rebuyButton = container.querySelector(".rebuy-button");
        if (rebuyButton) {
          clearInterval(interval);
          setTimeout(function () {
            if (document.querySelector('.block_cart-drawer-giftproduct')) {
              // addFreeGiftProduct();
            }
            moodRewars();
          }, 1000);
        }
      }
    }
  });


});

document.addEventListener('DOMContentLoaded', function () {
  const compareBtn = document.querySelector('.product__tocomparelist');
  if (compareBtn) {
    compareBtn.addEventListener('click', function () {
      const handle = this.dataset.handle;
      addToCompare(handle);
    });
  }
  function addToCompare(handle) {
    let compareList = JSON.parse(localStorage.getItem('compareList')) || [];
    if (!compareList.includes(handle)) {
      compareList.push(handle);
      localStorage.setItem('compareList', JSON.stringify(compareList));
    }
  }
});
//Executed after SWYM has loaded all necessary resources.
function onSwymLoadCallback(swat) {
  if (swat) {
    // console.log("Swym scripts tags are installed on your store");
    let event = 'sw:addedtocart';
    let listener = function (e) {
      var data = e.detail.d.productData;
      console.log("YAY! Added the product to cart", data);
      const cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) {
        cartIcon.click();
        setTimeout(() => {
          const swymCloseBtn = document.querySelector('#swym-storefront-layout-close-drawer-button');
          if (swymCloseBtn) {
            swymCloseBtn.click();
          }
        }, 300)

      }

    };
    swat.evtLayer.addEventListener(event, listener);
  }
  labelSwymWishlistLinks();
}

// WCAG 2.4.1 Bypass Blocks / 2.4.3 Focus Order / 2.4.7 Focus Visible
//
// The CLOSED cart drawer leaves ~61 focusable elements in the tab order. Verified in the
// browser: activating "Skip to content" then pressing Tab lands inside the drawer's Rebuy
// recommendation carousel for 12 presses before reaching the real navigation. A keyboard
// user tabs through invisible "Add to cart" buttons, with no visible focus indicator,
// and the skip link - whose whole purpose is bypassing blocks - is defeated.
//
// Mechanism: .drawer__inner is visibility:hidden when closed, but CSS visibility can be
// overridden by a descendant, and Splide's own stylesheet (served cross-origin from
// Rebuy's CDN) forces visibility:visible back onto the carousel root once it initialises.
//
// Fix keys off the .active class on <cart-drawer>, NOT the carousel id: Rebuy destroys
// and re-creates the carousel each time the drawer opens, incrementing the id
// (splide04 -> splide05), so any id-based selector breaks after the first reopen.
//
// `inert` is used rather than a CSS visibility override so there is no visual change at
// any point, including mid-close-animation. It removes descendants from both the tab
// order and the accessibility tree, which is exactly right for a closed drawer.
const supportsInert = 'inert' in HTMLElement.prototype;

function syncClosedDrawerInert() {
  document.querySelectorAll('cart-drawer').forEach((drawer) => {
    const isOpen = drawer.classList.contains('active');

    if (supportsInert) {
      // Only write when the state actually differs. This observer watches 'class' and
      // writes 'inert', so it does not currently re-enter itself, but it runs on every
      // DOM mutation on the page and an unconditional write is one filter change away
      // from becoming the same infinite loop documented on the patch observer below.
      if (isOpen) {
        if (drawer.hasAttribute('inert')) drawer.removeAttribute('inert');
      } else if (!drawer.hasAttribute('inert')) {
        drawer.setAttribute('inert', '');
      }
      return;
    }

    // Fallback for browsers without inert: take descendants out of the tab order and
    // restore them on open. data-drawer-tabbed marks only the ones we changed.
    drawer
      .querySelectorAll('a[href], button, input, select, textarea, [tabindex]')
      .forEach((el) => {
        if (isOpen) {
          if (el.dataset.drawerTabbed) {
            el.removeAttribute('tabindex');
            delete el.dataset.drawerTabbed;
          }
        } else if (el.getAttribute('tabindex') !== '-1') {
          el.dataset.drawerTabbed = 'true';
          el.setAttribute('tabindex', '-1');
        }
      });
  });
}

syncClosedDrawerInert();

if (document.body) {
  new MutationObserver(syncClosedDrawerInert).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class'],
  });
}

// WCAG 2.1.1 Keyboard - cart drawer quantity steppers respond to Space but not Enter.
//
// Both steppers on a line item are native <button type="button">, so the browser should
// fire click on BOTH keys for free. Verified in the browser that Enter does nothing, so
// something in the Measura virtual-stepper app is suppressing the default action. A
// control that only answers one of the two activation keys is not fully keyboard
// operable, and no automated scanner catches this - it needs a real key press.
//
// preventDefault() first, then dispatch the click ourselves. That way we cannot
// double-increment: if the native activation were working, preventDefault suppresses it,
// and exactly one click is dispatched either way.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter') return;

  const button = event.target.closest('.quantity__button, .measura-virtual-stepper-btn');
  if (!button || button.disabled) return;

  // Skip the hidden duplicate Dawn renders alongside the app's button.
  if (getComputedStyle(button).display === 'none' || getComputedStyle(button).visibility === 'hidden') return;

  event.preventDefault();
  button.click();
});

// Third-party accessibility patches (Rebuy / Discount Ninja).
//
// Both issues below are injected by apps we do not control, but they are injected into
// OUR page, so we can correct them here rather than wait on vendor releases. Same
// approach as the Swym wishlist labelling below. Re-run on mutation because both apps
// render asynchronously and Splide re-renders slides as the carousel moves.
//
// 1. WCAG 4.1.2 / Lighthouse aria-hidden-focus
//    Discount Ninja puts tabindex="0" on price elements. Inside a Rebuy carousel the
//    off-screen slides are aria-hidden="true", so those prices are focusable content
//    inside a hidden subtree - the exact axe failure. Rebuy's own links and buttons
//    already set tabindex="-1" correctly; this is not their bug.
//    A price is not interactive, so the tabindex is wrong in every state, not just when
//    hidden. Removing it fixes the audit and also removes meaningless tab stops.
//
// 2. Lighthouse aria-allowed-attr
//    aria-level="5" on the product-title anchors. CORRECTION: this is NOT Rebuy's
//    markup. Rebuy confirmed their default templates do not contain it, and they were
//    right - it came from OUR custom widget templates in snippets/*-rebuy-widget.liquid,
//    which are <script type="text/template"> blocks we maintain. Fixed at source; this
//    sweep stays only as a safety net in case a stale template is cached.
//    aria-level is valid only on roles such as heading; on a link it is not allowed.
function patchThirdPartyAccessibility() {
  document.querySelectorAll('.price-item[tabindex="0"], .price[tabindex="0"]').forEach((el) => {
    el.removeAttribute('tabindex');
  });

  document.querySelectorAll('a.rebuy-product-title[aria-level]').forEach((el) => {
    el.removeAttribute('aria-level');
  });

  // 3. ARIA 5.4 - empty headings. Yotpo renders <h4 class="yotpo-review-title"></h4> for
  //    reviews with no title, and a couple of rich-text fields contain a heading holding
  //    only &nbsp;. An empty heading is announced as a heading with no name and pollutes
  //    the heading outline. Hiding it from the accessibility tree is non-destructive -
  //    nothing is removed and nothing moves on screen.
  document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((h) => {
    // Bail before writing if it is already marked. setAttribute queues a MutationRecord
    // even when the value is unchanged, and the observer below watches aria-hidden, so
    // an unconditional write here re-enters this function forever. The callbacks are
    // microtasks, so the queue never drains and the page never paints - this took the
    // gift card page down once Yotpo rendered an untitled review.
    if (h.getAttribute('aria-hidden') === 'true') return;
    if (!h.textContent.replace(/ /g, ' ').trim() && !h.querySelector('img, svg')) {
      h.setAttribute('aria-hidden', 'true');
    }
  });

  // 4. ARIA 5.2.8.6 - Shopify's media_tag emits <video aria-label="..."> for product
  //    videos. A <video> has no ARIA role that permits naming, so the attribute is not
  //    allowed. The video already sits inside the gallery group, which carries the
  //    product name, so removing this loses nothing.
  document.querySelectorAll('video[aria-label]').forEach((v) => {
    v.removeAttribute('aria-label');
  });

  // 5. WCAG F65 - the same media_tag output renders video poster thumbnails as <img>
  //    with no alt attribute at all, so the image has no accessible name. They are
  //    decorative inside an already-labelled gallery, so an empty alt is correct.
  document.querySelectorAll('img:not([alt])').forEach((img) => {
    img.setAttribute('alt', '');
  });

  // Belt and braces: anything still focusable inside an aria-hidden subtree gets taken
  // out of the tab order, which is what the audit asks for.
  document.querySelectorAll('[aria-hidden="true"]').forEach((hidden) => {
    hidden
      .querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])')
      .forEach((el) => {
        if (el.getAttribute('tabindex') !== '-1') el.setAttribute('tabindex', '-1');
      });
  });
}

patchThirdPartyAccessibility();

// This sweep both reads and writes aria-hidden while the observer watches aria-hidden,
// so it must never see its own writes. Two independent safeguards, because relying on
// one of them is what caused the outage:
//   1. every write in the sweep is now conditional, so it converges on its own;
//   2. the observer is detached for the duration of the sweep, so it cannot re-enter
//      even if a future edit reintroduces an unconditional write.
// Runs are also coalesced to one per frame. The sweep queries the whole document, and
// Rebuy's carousel alone fires hundreds of mutations a second, so the previous
// run-per-mutation wiring was doing far more work than it needed to.
if (document.body) {
  const patchObserverOptions = {
    childList: true,
    subtree: true,
    attributeFilter: ['aria-hidden'],
  };

  let patchQueued = false;

  const patchObserver = new MutationObserver(() => {
    if (patchQueued) return;
    patchQueued = true;

    requestAnimationFrame(() => {
      patchQueued = false;
      patchObserver.disconnect();
      try {
        patchThirdPartyAccessibility();
      } finally {
        patchObserver.observe(document.body, patchObserverOptions);
      }
    });
  });

  patchObserver.observe(document.body, patchObserverOptions);
}

// WCAG 2.2.2: the banner videos autoplay, loop and run well past five seconds, with no
// way to stop them. Any auto-playing motion lasting more than 5s needs a pause mechanism.
// The videos are decorative (muted, aria-hidden), and they appear in several banner
// sections, so the control is injected once here rather than duplicated across markup.
// Users who ask for reduced motion get it paused from the start.
function addBannerVideoPauseControls() {
  document.querySelectorAll('video[autoplay]').forEach((video) => {
    if (video.dataset.pauseControlAdded) return;
    video.dataset.pauseControlAdded = 'true';

    const wrapper = video.parentElement;
    if (!wrapper) return;
    if (getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }

    // Prefer a control that is already in the markup. SortSite parses the served HTML
    // and does not credit a button injected from JS, so the banner sections now render
    // their own and this adopts it. Sections without one still get an injected button.
    let button = wrapper.querySelector(':scope > .banner-video-toggle');
    const buttonWasRendered = button !== null;

    if (!buttonWasRendered) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'banner-video-toggle';
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) video.pause();

    const sync = () => {
      const paused = video.paused;
      button.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
      button.setAttribute('aria-pressed', String(paused));
      button.textContent = paused ? '▶' : '⏸';
    };

    button.addEventListener('click', () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      sync();
    });

    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();

    if (!buttonWasRendered) wrapper.appendChild(button);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addBannerVideoPauseControls);
} else {
  addBannerVideoPauseControls();
}

// WCAG 4.1.2 / F89: Swym injects its wishlist links containing only an aria-hidden
// icon, so the link has no accessible name ("ARIA hidden" / empty-link errors in WAVE,
// "Links must have an accessible name" in SortSite). Swym declined to add a label and
// offers no setting for one, so we label the injected anchors ourselves.
// Swym re-injects on navigation and drawer events, so this runs on the load callback
// and again via an observer rather than once on DOMContentLoaded.
function labelSwymWishlistLinks() {
  document.querySelectorAll('a.swym-wishlist').forEach((link) => {
    if (!link.getAttribute('aria-label') && !link.textContent.trim()) {
      link.setAttribute('aria-label', 'Wishlist');
    }
  });
}

labelSwymWishlistLinks();

if (document.body) {
  new MutationObserver(labelSwymWishlistLinks).observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

if (document.querySelectorAll("#showPassword").length > 0) {
  document.getElementById('showPassword').onclick = function () {
    const showAsText = this.checked;

    // Select both password and confirm password fields
    document.querySelectorAll('input[name="customer[password]"], input[name="customer[password_confirmation]"]').forEach(function (input) {
      input.type = showAsText ? 'text' : 'password';
    });
  };
}


// document.getElementById('block_remove_account').addEventListener('click', function() {

// const SHOP = "moodfabric.myshopify.com";
// const API_TOKEN = "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";

// async function addCustomerTag(customerId, newTag) {
//   const res = await fetch(`https://${SHOP}/admin/api/2025-07/customers/${customerId}.json`, {
//     method: "PUT",
//     headers: {
//       "Content-Type": "application/json",
//       "X-Shopify-Access-Token": API_TOKEN
//     },
//     body: JSON.stringify({
//       customer: {
//         id: customerId,
//         tags: newTag // IMPORTANT: include old tags if you don’t want to overwrite them
//       }
//     })
//   });

//   const data = await res.json();
//   console.log("Customer updated:", data);
// }

// addCustomerTag("23384889491529", "arcticgrey");
// });



function openClearCartPopup() {
  document.getElementById("clearCartPopup").classList.add("open");
}
function closeClearCartPopup() {
  document.getElementById("clearCartPopup").classList.remove("open");
}
document.addEventListener("click", function (event) {
  const popup = document.getElementById("clearCartPopup");
  const popupContent = document.querySelector("#clearCartPopup .popup-content");
  if (popup.classList.contains("open") && !popupContent.contains(event.target)) {
    if (!event.target.closest("#clear-cart-btn")) {
      closeClearCartPopup();
    }
  }
});
document.querySelector(".clearcart_close-popup").addEventListener("click", function () {
  closeClearCartPopup();
});

function openPickupLocationPopup(locationName) {
  const popup = document.getElementById("pickupLocationPopup");
  if (!popup) return;

  // The showroom differs per product, so fill the template at open time.
  const message = popup.querySelector("[data-pickup-location-message]");
  if (message && locationName) {
    message.textContent = message.dataset.messageTemplate.replace("__LOCATION__", locationName);
  }

  popup.classList.add("open");
}
function closePickupLocationPopup() {
  const popup = document.getElementById("pickupLocationPopup");
  if (popup) popup.classList.remove("open");
}
document.addEventListener("click", function (event) {
  const popup = document.getElementById("pickupLocationPopup");
  if (!popup || !popup.classList.contains("open")) return;
  const popupContent = popup.querySelector(".popup-content");
  if (!popupContent.contains(event.target)) {
    closePickupLocationPopup();
  }
});

function openMixedCartPopup() {
  const popup = document.getElementById("mixedCartPopup");
  if (popup) popup.classList.add("open");
}
function closeMixedCartPopup() {
  const popup = document.getElementById("mixedCartPopup");
  if (popup) popup.classList.remove("open");
}
document.addEventListener("click", function (event) {
  const link = event.target.closest(".mixed-preorder-cart-warning-link");

  if (link) {
    event.preventDefault();
    openMixedCartPopup();
    return;
  }  
  const popup = document.getElementById("mixedCartPopup");
  if (!popup || !popup.classList.contains("open")) return;
  const popupContent = popup.querySelector(".popup-content");
  if (!popupContent.contains(event.target)) {
    closeMixedCartPopup();
  }
});

  // collection description readmore , readless
document.addEventListener("DOMContentLoaded", function () {
  const collectionDescElement = document.getElementById("collection-description");
  if (!collectionDescElement) return; // safe (inside function)

  let wrapper = collectionDescElement.querySelector(".collection-desc-paragraphs");

  if (!wrapper) {
    const elements = collectionDescElement.querySelectorAll(":scope > :not(h1)");

    if (elements.length) {
      wrapper = document.createElement("div");
      wrapper.classList.add("collection-desc-paragraphs");

      elements.forEach(el => wrapper.appendChild(el));
      collectionDescElement.appendChild(wrapper);
    }
  }

  const readMoreBtnElement = document.getElementById("read-more-btn");
  if (!readMoreBtnElement) return;



  // 👉 IMPORTANT: wrapper execute na thay to button hide

  if (!wrapper) {

    readMoreBtnElement.style.display = "none";

    return;

  }



  // Mobile only

  if (window.innerWidth > 576) {
    readMoreBtnElement.style.display = "none";
    return;
  }

  const isOverflowing = wrapper.scrollHeight > wrapper.clientHeight;
     if(document.querySelectorAll(".collection_icon").length < 1){
    readMoreBtnElement.classList.add("no-icon")
  }

  if (!isOverflowing) {
    readMoreBtnElement.style.display = "none";
  } else {
    let isExpanded = false;
    readMoreBtnElement.addEventListener("click", function () {
      collectionDescElement.classList.toggle("expanded");
      isExpanded = !isExpanded;
      readMoreBtnElement.textContent = isExpanded ? "Read Less" : "Read More";
    });
  }
});

document.addEventListener('click', async function (event) {
  const btn = event.target.closest('.buy-again-btn');
  if (!btn) return;

  let items;
  try {
    items = JSON.parse(btn.getAttribute('data-items'));
  } catch (e) {
    console.error('Parse error', e);
    return;
  }

  if (!items.length) return;

  btn.disabled = true;
  btn.textContent = 'ADDING...';

  const failedItems = []; // Track failed items

  try {
    const cartItems = await Promise.all(
      items.map(async (item) => {
        let properties = {};

        // ✅ HANDLE MEASURA ITEM
        if (item.is_measura && window.Measura) {
          try {
            const measuraProps = await window.Measura.buildLineItemProperties({
              productId: item.product_id,
              productHandle: item.handle,
              variantId: item.id,
              measurement: {
                dimensions: [
                  {
                    value: parseFloat(item.measurement_value),
                    unit: item.measurement_unit || 'yd' // make dynamic if provided
                  }
                ]
              },
              baseProperties: {
                "Buy Again": "true"
              }
            });

            // Convert array → object
            measuraProps.forEach((p) => {
              properties[p.name] = p.value;
            });

          } catch (err) {
            console.error(`Measura error for ${item.handle}:`, err);
            failedItems.push(item); // mark as failed
            return null; // skip adding to cart
          }
        }

        // ✅ NORMAL ITEM
        else {
          properties = item.properties || {};
        }

        return {
          id: item.id,
          quantity: item.quantity,
          properties
        };
      })
    );

    // Filter out nulls (failed Measura items)
    const itemsToAdd = cartItems.filter(Boolean);

    if (!itemsToAdd.length) {
      alert('No items could be added to the cart.');
      btn.disabled = false;
      btn.textContent = 'BUY AGAIN';
      return;
    }

    // Add remaining items to cart
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsToAdd })
    });

    if (!res.ok) {
      alert('Some items could not be added to the cart.');
      btn.disabled = false;
      btn.textContent = 'BUY AGAIN';
      return;
    }

    // Show warning if some items failed
    if (failedItems.length) {
      alert(
        `Some items could not be added to the cart:\n${failedItems
          .map(i => i.title || i.handle)
          .join('\n')}`
      );
    }

    window.location.href = '/cart';

  } catch (err) {
    console.error(err);
    btn.disabled = false;
    btn.textContent = 'BUY AGAIN';
    alert('Error adding items to cart. Some items may be out of stock.');
  }
});

/* ---------------------------------------------------------------------------
   Wishlist link accessible name (WCAG 4.1.2, 1.3.1).

   The NVDA audit heard only "link, Wishlist" and never the item count. The count
   lives in a sibling <span> that Swym fills in asynchronously, so it is outside
   the link's accessible name entirely - the static aria-label="Wishlist" was all
   a screen reader ever got.

   The link's aria-label is now kept in sync with that span, so it announces
   "link, Wishlist, 0 items on Wishlist" and updates as items are added.
--------------------------------------------------------------------------- */
(function () {
  const WISHLIST_LINK = 'a[data-wishlist-link]';
  const COUNTER = '.swym-wishlist-header-counter';

  function labelFor(count) {
    return count === 1 ? 'Wishlist, 1 item on Wishlist' : `Wishlist, ${count} items on Wishlist`;
  }

  function readCount(counter) {
    if (!counter) return 0;
    const digits = (counter.textContent || '').replace(/[^0-9]/g, '');
    const value = parseInt(digits, 10);
    return Number.isNaN(value) ? 0 : value;
  }

  function syncWishlistLabel(wrapper) {
    const link = wrapper.querySelector(WISHLIST_LINK);
    if (!link) return;
    link.setAttribute('aria-label', labelFor(readCount(wrapper.querySelector(COUNTER))));
  }

  function initWishlistLabels() {
    document.querySelectorAll('.swym-wishlist').forEach((wrapper) => {
      if (wrapper.dataset.a11yWishlistInit) return;
      wrapper.dataset.a11yWishlistInit = 'true';

      syncWishlistLabel(wrapper);

      // Swym writes the count in after its script loads, and again on every
      // add/remove, so the label has to follow rather than being set once.
      const counter = wrapper.querySelector(COUNTER);
      if (!counter) return;
      new MutationObserver(() => syncWishlistLabel(wrapper)).observe(counter, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistLabels);
  } else {
    initWishlistLabels();
  }
})();

/* ---------------------------------------------------------------------------
   Skip to Content (WCAG 2.4.1 Bypass Blocks).

   The markup was already correct - the link targets #MainContent and that
   element carries tabindex="-1" - yet the NVDA audit reported the control doing
   nothing. Relying on default in-page anchor behaviour is the usual cause: some
   browser and screen reader combinations move the reading cursor without moving
   real keyboard focus, so the next Tab drops the user back into the header they
   were trying to bypass.

   Moving focus explicitly on activation makes the behaviour the same everywhere.
--------------------------------------------------------------------------- */
(function () {
  const skipLink = document.querySelector('a.skip-to-content-link');
  if (!skipLink) return;

  skipLink.addEventListener('click', (event) => {
    const targetId = (skipLink.getAttribute('href') || '').replace('#', '');
    const target = targetId && document.getElementById(targetId);
    if (!target) return; // let the browser do whatever it would have done

    event.preventDefault();

    // tabindex is already in the markup, but a section render can replace the
    // node, so it is reasserted rather than assumed.
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');

    target.focus();
    target.scrollIntoView({ block: 'start' });
  });
})();

/* ---------------------------------------------------------------------------
   Carousel arrows - keyboard operation (WCAG 2.1.1).

   The collection slider arrows are <div>s that Swiper binds click handlers to, so
   they worked with a mouse and not at all with a keyboard. They now carry
   role="button", an accessible name and tabindex in the markup; this forwards
   Enter and Space to the click Swiper is already listening for, rather than
   reimplementing the slider's own navigation.
--------------------------------------------------------------------------- */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;

  const arrow = event.target.closest('[role="button"][class*="block_collection-slider-arrow"]');
  if (!arrow) return;

  event.preventDefault();
  arrow.click();
});

/* ---------------------------------------------------------------------------
   Rebuy carousel reading order (WCAG 1.3.1 / 2.4.3).

   The NVDA audit found the previous/next arrows announced before every product in
   the Seasonal Fabrics carousel. Confirmed on the live page: Rebuy renders these
   grids with Splide, and .splide__arrows sits before .splide__track in source
   order, so browse mode reaches the controls before the content they control.

   The arrows are moved after the track. Reading order follows the DOM, so CSS
   alone could not fix this. Splide's handlers are bound to the button elements
   themselves and survive the move, and the arrows are absolutely positioned, so
   there is no visual change.

   Deliberately defensive: this touches third-party markup, so it only acts when
   both nodes are present and the order is actually wrong, and it re-checks on
   mutation because Rebuy renders asynchronously and can re-render.
--------------------------------------------------------------------------- */
(function () {
  function fixCarouselOrder(root) {
    (root || document).querySelectorAll('.rebuy-product-grid .splide, .rebuy-widget .splide').forEach((splide) => {
      const arrows = splide.querySelector(':scope > .splide__arrows');
      const track = splide.querySelector(':scope > .splide__track');
      if (!arrows || !track) return;

      // Only act when the arrows really do come first.
      if (!(arrows.compareDocumentPosition(track) & Node.DOCUMENT_POSITION_FOLLOWING)) return;

      track.after(arrows);
    });
  }

  function start() {
    fixCarouselOrder(document);
    new MutationObserver(() => fixCarouselOrder(document)).observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---------------------------------------------------------------------------
   Homepage SEO intro copy - mobile "Read more" control.

   The copy lives in a custom-liquid section the merchant edits, so the control is
   injected here rather than written into the content. That keeps the text fully
   editable in the theme editor and means the button cannot be lost by a content
   edit.

   The full text stays in the DOM in every state - it is clipped with max-height,
   never display:none - so search engines still read all of it. That is the whole
   reason for the change: the section was previously hidden outright on mobile.
--------------------------------------------------------------------------- */
(function () {
  const COLLAPSED_CLASS = 'is-expanded';
  const LABEL_MORE = 'Read more';
  const LABEL_LESS = 'Read less';

  function initHeroReadMore() {
    document.querySelectorAll('.mood-hero-paragraphs').forEach((copy, index) => {
      if (copy.dataset.readMoreInit) return;
      copy.dataset.readMoreInit = 'true';

      if (!copy.id) copy.id = `mood-hero-paragraphs-${index + 1}`;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mood-hero-readmore';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', copy.id);
      button.textContent = LABEL_MORE;

      button.addEventListener('click', () => {
        const expanded = copy.classList.toggle(COLLAPSED_CLASS);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? LABEL_LESS : LABEL_MORE;
      });

      copy.insertAdjacentElement('afterend', button);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroReadMore);
  } else {
    initHeroReadMore();
  }
})();

/* ----------------------------------------------------------------------------
   In-store QR referral attribution
   ----------------------------------------------------------------------------
   An in-store QR code sends the shopper to the site with ?ref=<code>, for
   example https://www.moodfabrics.com/?ref=qr_chicagostore. They can land on
   any page. If they order within the attribution window, the order should
   carry that store's tag.

   The theme cannot tag an order - that needs the Admin API. What happens here
   is that the referral is recorded and attached to the cart as an attribute,
   which travels through to the order. A Shopify Flow workflow reads that
   attribute on order creation and applies the tag.

   The previous app (TagMate) only attributed a purchase made in the same
   session. localStorage widens that to the configured window. Its limit is
   that it is per browser: a scan on a phone followed by a purchase on a laptop
   cannot be attributed by any client-side method.

   Last touch wins - a second scan overwrites the store and restarts the clock.

   The attribute is re-asserted rather than written once. /cart/update.js merges,
   so attributes set by other apps are never clobbered by us, and theirs cannot
   clobber ours. But an app using the Storefront API cartAttributesUpdate
   mutation replaces the whole attribute set, and /cart/clear.js runs on logout
   in this theme. Re-writing on each cart change means any such wipe is repaired
   before checkout.

   Config comes from theme.liquid (settings: "QR Store Referral Tracking").
---------------------------------------------------------------------------- */
(function () {
  const config = window.moodQrReferral;

  // Three distinct outcomes, deliberately kept distinguishable. Returning
  // silently for all three is what let a truncated theme.liquid look exactly
  // like the feature being switched off, and cost a long hunt to tell apart.
  if (!config) {
    console.warn(
      '[QR referral] window.moodQrReferral is missing: theme.liquid did not render ' +
        'the config bridge, so QR attribution is inactive.'
    );
    return;
  }
  if (config.enabled === false) return; // switched off in the theme editor, on purpose
  if (!config.map || Object.keys(config.map).length === 0) {
    console.warn('[QR referral] no referral codes are configured, so nothing will be attributed.');
    return;
  }

  const STORAGE_KEY = 'mood_qr_referral';
  const SYNCED_KEY = 'mood_qr_referral_synced';
  const URL_PARAM = 'ref';
  const attributeKey = config.attributeKey || '_mood_qr_store';
  const windowMs = (Number(config.windowDays) || 30) * 24 * 60 * 60 * 1000;

  function readReferral() {
    let raw;
    try {
      raw = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null; // private browsing, or storage blocked
    }
    if (!raw) return null;

    let stored;
    try {
      stored = JSON.parse(raw);
    } catch (e) {
      return null;
    }
    if (!stored || !stored.tag) return null;

    // Number(), not a truthiness check: a timestamp of 0 is a real value and
    // must reach the expiry branch below so the entry is purged, rather than
    // being treated as malformed and silently left in place.
    const storedAt = Number(stored.ts);
    if (!isFinite(storedAt)) return null;

    if (Date.now() - storedAt > windowMs) {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
      return null;
    }

    return stored.tag;
  }

  function storeReferral(tag) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ tag: tag, ts: Date.now() }));
    } catch (e) {}
    try {
      sessionStorage.removeItem(SYNCED_KEY); // a new store must be pushed to the cart
    } catch (e) {}
  }

  function captureFromUrl() {
    let code;
    try {
      code = new URLSearchParams(window.location.search).get(URL_PARAM);
    } catch (e) {
      return;
    }
    if (!code) return;

    // An unrecognised code is ignored rather than guessed at, so a typo in a
    // printed QR code never tags an order with the wrong store.
    const tag = config.map[code.trim().toLowerCase()];
    if (!tag) return;

    storeReferral(tag);
  }

  function syncToCart(tag) {
    const attributes = {};
    attributes[attributeKey] = tag;

    return fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function () {
        try {
          sessionStorage.setItem(SYNCED_KEY, tag);
        } catch (e) {}
      })
      .catch(function () {}); // attribution must never break the page
  }

  captureFromUrl();

  const tag = readReferral();
  if (!tag) return;

  // Written once per session on load, so ordinary navigation does not add a
  // request to every page once the cart already carries the attribute.
  let alreadySynced = false;
  try {
    alreadySynced = sessionStorage.getItem(SYNCED_KEY) === tag;
  } catch (e) {}
  if (!alreadySynced) syncToCart(tag);

  // Re-assert after a cart mutation, the point at which another app is most
  // likely to have rewritten or cleared the attribute set.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      const current = readReferral();
      if (current) syncToCart(current);
    });
  }
})();
